import { StreamActivityPhase } from '../models/chat.models';

const PHASE_LABELS: Record<StreamActivityPhase, string> = {
  generating_artifact: 'Building visualization…'
};

/**
 * Reads the phase of a `status` SSE payload, or null when it is one this build does not know: the
 * backend may add phases at any time and an unrecognised one must be a no-op rather than an empty
 * indicator (DATA-1410).
 */
export function resolveStreamActivityPhase(phase: string): StreamActivityPhase | null {
  return isKnownPhase(phase) ? phase : null;
}

/** The line shown under the answer while the phase runs, e.g. "Building visualization…". */
export function formatStreamActivityLabel(phase: StreamActivityPhase | null | undefined): string {
  return phase ? PHASE_LABELS[phase] : '';
}

function isKnownPhase(phase: string): phase is StreamActivityPhase {
  return Object.prototype.hasOwnProperty.call(PHASE_LABELS, phase);
}
